define("shared/utils/formatters/caption", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Formats the caption of a Later Post
   * Instagram:
   * prevent IG from swallowing continuous newline characters by adding a zero width no break space
   * \u2063, \u2800 and \uFEFF are not good candidates
   * Twitter:
   * automatically remove invalid chars sourced from twitter-text
   * https://github.com/twitter/twitter-text/blob/master/js/src/regexp/invalidCharsGroup.js
   *
   * @method formatCaption
   * @param {Object} post scheduled Post
   *
   * @returns {Object} scheduled Post with formatted caption
   */

  const formatCaption = post => {
    if (post.get('socialProfile.isInstagram')) {
      const newCaption = post.caption
      // remove whitespace between continous newlines
      .replace(/\n[ \f\t\v]+?\n/g, '\n\n')
      // add invisible seperator before every newline
      .replace(/(?:\u2060)?(?:\r\n?|\n)/g, '\u2060\n');
      if (post.caption !== newCaption && newCaption.length <= post.maxCharacters) {
        post.set('caption', newCaption);
      }
    }
    if (post.get('socialProfile.isTwitter')) {
      const invalidCharsGroup = /\uFFFE|\uFEFF|\uFFFF/g;
      const newCaption = post.caption.replace(invalidCharsGroup, '');
      if (post.caption !== newCaption) {
        post.set('caption', newCaption);
      }
    }
    return post;
  };
  var _default = _exports.default = formatCaption;
});